// probeForZendeskLauncher is for when the side drawer is open, but the zendesk widget has not rendered yet
// we continue to check the DOM every 250ms to see if the zendesk has rendered and hide it if the drawer is open
// *** this rarely happens but we still need to handle it
export function probeForZendeskLauncherForSideDrawer(): void {
  if (!isSideDrawerOpen()) {
    return;
  }
  window.setTimeout(() => {
    const launcher = getZendeskLauncher();
    if (launcher) {
      closeZendeskLauncher();
    } else {
      probeForZendeskLauncherForSideDrawer();
    }
  }, 250);
}
export function probeForZendeskLauncherThenClose(): void {
  window.setTimeout(() => {
    const launcher = getZendeskLauncher();
    if (launcher) {
      closeZendeskLauncher();
    } else {
      probeForZendeskLauncherThenClose();
    }
  }, 250);
}
export function getZendeskLauncher(): HTMLElement {
  return document.querySelector('#launcher') || null;
}

export function closeZendeskLauncher(): void {
  const launcher = getZendeskLauncher();
  if (launcher) {
    launcher.parentElement.style.display = 'none';
  }
}

export function openZendeskLauncher(): void {
  const launcher = getZendeskLauncher();
  if (launcher) {
    launcher.parentElement.style.display = '';
  }
}

function isSideDrawerOpen(): boolean {
  const sideDrawer = document.querySelector('.mat-drawer-end');
  return !!sideDrawer;
}

export function checkZendeskIsOpen(): boolean {
  const launcher = getZendeskLauncher();
  if (launcher) {
    return launcher.parentElement.style.display === '';
  }
}
